// src/components/TarjetaPackaging.jsx
import { Boton } from '../Boton'; // Ajusta la ruta si es necesario

// Solo una declaración de la función. (Error "already been declared" corregido aquí)
export function obtenerEstadoChecklist(checklist) {
  if (!Array.isArray(checklist)) return { texto: "PENDIENTE", clase: "pendiente" };

  const orden = [
    "Pedido solicitado",
    "Regulatory revisado",
    "Cotizado por compras",
    "Diseño revisado",
    "Proveedor validado",
    "Pedido compras validado"
  ];

  const estados = [
    { texto: "PDTE REGULATORY", clase: "pendiente-regulatory" },
    { texto: "PDTE COTIZACIÓN", clase: "pendiente-compras" },
    { texto: "PDTE DISEÑO", clase: "pendiente-diseno" },
    { texto: "PDTE PROVEEDOR", clase: "pendiente-proveedor" },
    { texto: "PDTE COMPRAS", clase: "pendiente-pedido" },
    { texto: "COMPLETADO", clase: "completado" }
  ];

  for (let i = 0; i < orden.length; i++) {
    const item = checklist.find(c => c.etiqueta === orden[i]);
    if (!item?.validado) {
      return i === 0 ? { texto: "PENDIENTE", clase: "pendiente" } : estados[i - 1];
    }
  }

  return estados[estados.length - 1];
}

export function TarjetaPackaging({ packaging, onClick }) {
  const { codigoAS400, nombreComercial, descripcion, medidas, tipo, formato, material, color } = packaging;
  const estado = obtenerEstadoChecklist(packaging.checklist);

  return (
    <div className="tarjeta" onClick={onClick}>
      <div className={`estado-tarjeta ${estado.clase}`}>{estado.texto}</div>

      <h3>{nombreComercial}</h3>
      <p><strong>Código:</strong> {codigoAS400}</p>
      <p><strong>Tipo:</strong> {tipo} ({formato}) | <strong>Medidas:</strong> {medidas.alto}x{medidas.ancho}x{medidas.largo} cm</p>
      <p><strong>Material:</strong> {material} | <strong>Color:</strong> {color}</p>
      <p><strong>Proveedor:</strong> {packaging.proveedor}</p>
      <p>{descripcion}</p>

      {Array.isArray(packaging.checklist) && (
        <div className="checklist">
          {packaging.checklist.map((item, idx) => ( // key={idx} está bien si la lista de checklist es estática/no cambia de orden
            <div className="check-item" key={idx}>
              <div className={`check-circle ${item.validado ? 'completo' : ''}`}></div>
              <span className="check-text">{item.etiqueta} -&nbsp;</span>
              {item.fecha && !isNaN(new Date(item.fecha)) ? (
                <span className="check-date">
                  {new Intl.DateTimeFormat('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(item.fecha))}
                </span>
              ) : (
                <span className="check-date pendiente">Pendiente</span>
              )}
            </div>
          ))}
        </div>
      )}

      <div style={{ marginTop: '1em', display: 'flex', gap: '0.5rem' }}>
        {/* Los botones son tamaño little, tipo exito y peligro */}
        {/* Nota: onClick={(e) => e.stopPropagation()} es crucial para que el clic del botón no cierre el modal */}
        <Boton tipo="exito" texto="Ver" size="little" onClick={(e) => e.stopPropagation()} />
        <Boton tipo="peligro" texto="Borrar" size="little" onClick={(e) => e.stopPropagation()} />
      </div>
    </div>
  );
}